import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createTypeOfReport, updateReport,
getTypeOfReports, deleteReport } from '../../actions/reportActions'
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const ReportCategorieAdmin = ({ history, createTypeOfReport, updateReport, typeOfReports, getTypeOfReports, deleteReport, isLoadingTypeOfReports }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getTypeOfReports()
        })
        
    },[])

    console.log()
    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [nameCategorie, setNameCategorie] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})
    const [isEnable, setEnable] = useState(false)

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }


    const isEmpty = (e) => {
        if (nameCategorie !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nueva'} categoria para reporte`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Nombre:'}
                    </div>
                    <input
                        name='nameCategorie'
                        className='inputs-admin'
                        value={nameCategorie}
                        onChange={(e) => {
                            setNameCategorie(e.target.value.trimStart())
                            if (nameCategorie !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.name}</div>

                    {isEdit ?
                        <div className="column">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setNameCategorie('')
                                setEnable(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    updateReport({ description: nameCategorie.trim(), typeID: idEdit }, history, indexEdit)
                                    setNameCategorie('')
                                    setEnable(false)
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { createTypeOfReport({ description: nameCategorie.trim() }, history) }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>

                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Categorias existentes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingTypeOfReports ? <div>Cargando...</div> :
                        typeOfReports.map((categorie, index) => (
                            <div key={categorie._id} className="mb-2 row mr-3 ml-2 card-admin">
                                <div className="tittle-card-admin">{categorie.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNameCategorie(categorie.description)
                                        setIdEdit(categorie._id)
                                        setEnable(categorie.isEnable)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deleteReport(categorie._id, index) }}>Eliminar</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingTypeOfReports: state.postAdmin.isLoadingTypeOfReports,
        typeOfReports: state.postAdmin.typeOfReports
    }
}


export default connect(mapStateToProps, { createTypeOfReport, updateReport, getTypeOfReports, deleteReport })(ReportCategorieAdmin)